module.exports = __webpack_public_path__ + "img/zw.04a72f26.svg";